import { useState } from 'react';
import { dataURLtoBlob, AvatarTypes, uploadAvatar as uploadAvatarHelper, baseRESTUrl } from "lib/utils";
import { userClient } from 'lib/clients';
import { useAppDispatch } from 'lib/redux';
import { refreshAvatar, refreshMe } from 'domains/account';

type State = {
  position: any;
  scale: number;
  rotate: number;
  pickImg: any;
  id: number;
  description: string;
}

const acceptedFileTypes: string[] = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];

const initialState = {
  position: null,
  scale: 1,
  rotate: 0,
  pickImg: null,
  id: 0,
  description: ''
}

export const useAvatar = () => {
  const [thumbnailState, setThumbnailState] = useState<State>(initialState);
  const dispatch = useAppDispatch();

  const uploadAvatar = async (avatar) => {
    try {
      await uploadAvatarHelper(
        AvatarTypes.USER,
        dataURLtoBlob(avatar.toDataURL()),
        percent => console.log(percent)
      );

      setThumbnailState(initialState);
    } catch (err) {
      console.log(err);
      let description = 'The image was not able to be uploaded at this time. Please check your connection and try again later.';

      if (err?.status === 413) {
        description = 'The image is too large. The max file size allowed is 1GB.';
      }

      return description;
    }
  }

  const handleFiles = (files: any) => {
    try {
      if (!files.length) {
        return;
      }

      const file = files[files.length - 1];

      if (!acceptedFileTypes.includes(file.type)) {
        throw new Error('Icon can only be a GIF, PNG or JPG');
      }

      setThumbnailState((prevState) => ({
        ...initialState,
        pickImg: file,
        id: prevState.id + 1
      }));
    } catch (err) {
      return err;
    }
  }

  const removeAvatar = async () => {
    await userClient.deleteAvatar();
    await dispatch(refreshMe(baseRESTUrl()))
    setThumbnailState(initialState);
    dispatch(refreshAvatar());
  }

  return {
    uploadAvatar,
    thumbnailState,
    setThumbnailState,
    handleFiles,
    acceptedFileTypes,
    removeAvatar
  }
}